import { ExclamationCircleFilled, LinkOutlined } from "@ant-design/icons";
import { formItemLayout } from "Admin/Config/FormLayout";
import { IconPack } from "Admin/Config/Icon";
import {
  createProfileEducation,
  deleteProfileEducation,
  getProfileEducation,
} from "Admin/Service/Profile";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { LoadingListEntityProfile } from "Explore/Components";
import {
  Button,
  Empty,
  Form,
  Input,
  Modal,
  Tooltip,
  Typography,
  message,
} from "antd";
import { useEffect, useState } from "react";
import styles from "./Education.module.scss";
const { confirm } = Modal;
const { Paragraph, Text, Link } = Typography;

const QuotationAndCitation = ({ quotation, citationURL }) => {
  const displayText =
    quotation?.length > 0
      ? quotation
      : "The information is extracted but not yet verified";
  return (
    <div>
      <Paragraph>
        <Link href={citationURL} target="_blank">
          <LinkOutlined />
        </Link>
        &nbsp;
        <Text type="secondary" style={{ fontStyle: "italic" }}>
          {displayText}
        </Text>
        <Tooltip title={citationURL}></Tooltip>
      </Paragraph>
    </div>
  );
};

const Education = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState({
    data: [],
    isLoading: true,
    source_url: null,
  });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [openAddEducationModal, setOpenAddEducationModal] = useState(false);
  const [openDeleteEducationModal, setOpenDeleteEducationModal] =
    useState(false);
  useEffect(() => {
    setData({ data: [], isLoading: true });
    getProfileEducation(pagination.page - 1, pagination.rowsPerPage, (res) => {
      handleAPIResponse(res, () => {
        setData({
          data: res.data.education,
          isLoading: false,
          source_url: res.data.education_source_url,
        });
        if (res.data.total) {
          setPagination({
            ...pagination,
            totalRows: res.data.total,
          });
        }
      });
    });
  }, []);
  const Education = ({ education }) => {
    var graduationString = education.graduation_year
      ? ` (${education.graduation_year})`
      : "";
    return (
      <div className={styles["education-wrapper"]}>
        <div className={styles["education"]}>
          <div className={styles["education-info"]}>
            <p className={styles["inst-name"]}>{education.institution}</p>
            {education.degree && (
              <p>
                {education.degree} {graduationString}
              </p>
            )}
            <QuotationAndCitation
              quotation={
                education.raw?.length > 0
                  ? `"...` + education.raw.join(". ") + `..."`
                  : ""
              }
              citationURL={data.source_url}
            />
          </div>
        </div>
        <div
          className={styles["delete-education"]}
          onClick={() => handleDeleteEducation(education)}
        >
          {IconPack.delete_icon}
        </div>
      </div>
    );
  };
  const handleAddEducation = () => {
    createProfileEducation(form.getFieldsValue(), (res) => {
      handleAPIResponse(res, () => {
        setData({
          ...data,
          data: [form.getFieldsValue(), ...data.data],
        });
      });
    });
    setOpenAddEducationModal(false);
  };
  const handleDeleteEducation = (education) => {
    const payload = {
      education_year: education.education_year,
      degree: education.degree,
      institution: education.institution,
    };
    confirm({
      title: "Are you sure delete this education?",
      icon: <ExclamationCircleFilled />,
      content: "This action is irreversible.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      open: openDeleteEducationModal,
      onOk() {
        deleteProfileEducation(payload, (res) => {
          handleAPIResponse(res, () => {
            const updateList = data.data.filter((item) => item !== education);
            setData({ data: updateList, isLoading: false });
            message.success("Delete education successfully");
            setOpenDeleteEducationModal(false);
          });
        });
      },
      onCancel() {
        setOpenDeleteEducationModal(false);
      },
    });
  };
  return (
    <div className={styles["educations"]}>
      <Modal
        title="Add education"
        open={openAddEducationModal}
        onOk={handleAddEducation}
        width={1000}
        onCancel={() => setOpenAddEducationModal(false)}
      >
        <Form
          {...formItemLayout}
          form={form}
          onFinish={handleAddEducation}
          layout="vertical"
        >
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Institution:"}
            labelAlign="left"
            name="institution"
          >
            <Input placeholder="Please input the institution name" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Year:"}
            labelAlign="left"
            name="education_year"
          >
            <Input placeholder="Please input the education year" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Degree:"}
            labelAlign="left"
            name="degree"
          >
            <Input placeholder="Please input the degree" />
          </Form.Item>
        </Form>
      </Modal>
      <div className={styles["add-button"]}>
        <Button type="primary" onClick={() => setOpenAddEducationModal(true)}>
          Add education
        </Button>
      </div>
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data?.data?.length > 0 ? (
            data?.data?.map((item, index) => {
              return <Education education={item} key={index} />;
            })
          ) : (
            <Empty description="No Education Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
    </div>
  );
};

export default Education;
